const doc = [({"ko":({"adminComponentHotelMail":({"arrangedInformationDescription":"시설에서 예약 확정했을 때의 메일로 표시됩니다", "hotelMailTitle":"이메일 설정", "informationTitle":"문의 사항"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;